import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import { useContent } from "@/content/ContentProvider";

export default function ClassSystem() {
  const levels = useContent("home.levels");

  return (
    <section className="relative overflow-hidden bg-foreground-950 py-20 md:py-28">
      <div className="pointer-events-none absolute inset-0 grain-light opacity-30" />
      <div className="relative mx-auto max-w-content px-5 md:px-8">
        <Reveal className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <span className="font-label text-xs tracking-[0.25em] text-primary-500">
              CLASS SYSTEM
            </span>
            <h2 className="mt-3 font-heading text-3xl font-black tracking-tight text-white md:text-5xl">
              학년별로 다른
              <br />
              <span className="text-primary-500">맞춤 커리큘럼</span>
            </h2>
          </div>
          <Link
            to="/classes"
            className="inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-full border border-white/25 px-6 py-3 text-sm font-bold text-white transition-colors hover:bg-white/10 cursor-pointer"
          >
            수업안내 자세히 보기
            <i className="ri-arrow-right-line" />
          </Link>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-3">
          {levels.map((level, idx) => (
            <Reveal key={level.key} delay={idx * 90}>
              <article className="group h-full overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] transition-colors duration-300 hover:border-primary-500/40">
                <div className="relative h-48 w-full overflow-hidden">
                  <img
                    src={level.image}
                    alt={`${level.name} ${level.headline} 수업 이미지`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-4 top-4 rounded-full bg-foreground-950/80 px-3 py-1 font-label text-[10px] tracking-[0.2em] text-primary-400">
                    {level.tag}
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="font-heading text-xl font-black tracking-tight text-white">
                    {level.name}
                  </h3>
                  <p className="mt-1 font-heading text-sm font-bold text-primary-500">
                    {level.headline}
                  </p>
                  <p className="mt-3 text-sm leading-relaxed text-white/60">
                    {level.desc}
                  </p>
                  <ul className="mt-5 space-y-2">
                    {level.points.map((point) => (
                      <li key={point} className="flex items-center gap-2 text-sm text-white/70">
                        <i className="ri-check-line text-primary-500" />
                        {point}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}